'use client';

import dynamic from 'next/dynamic';
import React from 'react';
import { FormBuilder } from '@/sanity.types';

// Import the SignupSearchForm component dynamically with SSR disabled
const SignupSearchForm = dynamic(() => import('./SignupSearchForm'), {
  ssr: false,
});

interface DynamicSignupFormProps {
  formData: FormBuilder;
}

export default function DynamicSignupForm({
  formData,
}: DynamicSignupFormProps) {
  return <SignupSearchForm formData={formData} />;
}
